import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito ingredientes caros?',
    a: 'No. Usamos comida real que encuentras en cualquier mercado local. De hecho, al dejar de comprar productos ultraprocesados empaquetados, la mayoría de las familias ahorran dinero en su compra semanal.'
  }, {
    q: '¿Tengo que cocinar mucho?',
    a: "El menú está diseñado específicamente para padres ocupados. Incluimos preparaciones rápidas, efectivas y estrategias de 'batch cooking' (cocinar por lotes) para minimizar tu tiempo en la cocina."
  }, {
    q: '¿Mi hijo se dará cuenta del cambio?',
    a: 'No si usas las técnicas de infiltración que te enseñamos. El objetivo es hacer una transición suave donde el sabor de sus comidas favoritas se mantiene, pero la densidad nutricional se multiplica.'
  }, {
    q: '¿Sirve para niños adolescentes?',
    a: 'El menú y las porciones están optimizados para la etapa crítica de crecimiento (2-12 años), pero los principios de lectura de etiquetas y estabilización metabólica sirven para cualquier miembro de la familia, sin importar la edad.'
  }];
  return <section className="py-14 bg-cream" data-id="element-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <FadeIn data-id="element-18">
          <div className="text-center mb-10" data-id="element-19">
            <h2 className="text-3xl md:text-4xl font-bold text-ink mb-6" data-id="element-20">
              Preguntas Frecuentes
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-21">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} index={index} data-id="element-22" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <FadeIn delay={index * 0.1} data-id="element-23">
      <div className="bg-white rounded-2xl border border-ink/5 overflow-hidden" data-id="element-24">
        <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-25">
          <span className="font-bold text-ink text-lg pr-4" data-id="element-26">{question}</span>
          <motion.div animate={{
          rotate: isOpen ? 180 : 0
        }} transition={{
          duration: 0.3
        }} className="flex-shrink-0 text-leaf" data-id="element-27">
            <ChevronDownIcon className="w-6 h-6" data-id="element-28" />
          </motion.div>
        </button>
        <AnimatePresence data-id="element-29">
          {isOpen && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-30">
              <div className="px-6 pb-5 text-ink/70 leading-relaxed" data-id="element-31">
                {answer}
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </FadeIn>;
}